import React, {useState} from 'react'
import {Button, Checkbox, List, Modal} from 'antd'
import {PlantCollection} from '../../entities/plant'
import {useIntl} from 'react-intl'
import './todos.less'

export type SelectCollectionsModalProps = {
  userCollections: PlantCollection[]
  isOpen: boolean
  onCloseNewSelected: () => void
  onCancel: () => void
  chosenUserCollections: Partial<Record<number, boolean>>
  setChosenUserCollections: (chosenUserCollections: Partial<Record<number, boolean>>) => void
}

export function SelectCollectionsModal({
  userCollections,
  isOpen,
  onCloseNewSelected,
  onCancel,
  chosenUserCollections,
  setChosenUserCollections,
}: SelectCollectionsModalProps) {
  const intl = useIntl()

  return (
    <Modal
      className="collections-select"
      open={isOpen}
      onCancel={onCancel}
      title={intl.formatMessage({id: 'collections'})}
      destroyOnHidden
      okText={intl.formatMessage({id: 'select'})}
      onOk={onCloseNewSelected}
    >
      <div>
        {intl.formatMessage({id: 'selectPlantsFromTheMarkedCollections'})}:
        <List
          className="collections-select__list"
          itemLayout="horizontal"
          dataSource={[...userCollections]}
          renderItem={(item) => (
            <List.Item>
              <div>
                <Checkbox
                  checked={chosenUserCollections[item.id]}
                  onChange={(e) => {
                    const {checked} = e.target

                    setChosenUserCollections({
                      ...chosenUserCollections,

                      [item.id]: checked,
                    })
                  }}
                >
                  {item.name}
                </Checkbox>
              </div>
            </List.Item>
          )}
        />
        {/* <Button
          type="primary"
          onClick={() => {
            onCloseNewSelected()
          }}
        >
          {intl.formatMessage({id: 'select'})}
        </Button> */}
      </div>
    </Modal>
  )
}
